import { Routes, Route } from "react-router-dom";
// import ClientLayout from "../layouts/ClientLayout";
import TaskBoardWrapper from "../pages/fonctionel/TaskBoardWrapper";
import FonctionelLayout from "../layouts/FonctionnelLayout";
import TicketDetailCard from "../pages/fonctionel/PageDetail";
import TableauBordFonctionnel from "../pages/fonctionel/TableauBordFonctionnel";
import DashboardFonctionnel from "../pages/fonctionel/Dashboard";
// import TaskDetailPage from "../pages/technique/TaskDetailPage";
// import TicketForm from "../pages/technique/AddTaskForm";

const FonctionelRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<FonctionelLayout />}>
                <Route
                    path="dashboardF"
                    element={<TableauBordFonctionnel  />}
                />
                <Route path="home" element={<TaskBoardWrapper />} />
                <Route
                    path="task/:id"
                    element={<TicketDetailCard />}
                />
                <Route path="Dashboard" element={<DashboardFonctionnel />} />

                {/* <Route path="/task/:taskId" element={< TaskDetailPage/>} />
                <Route path="task/create" element={<TicketForm />} /> */}
            </Route>
        </Routes>
    );
};

export default FonctionelRoutes;
